import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-too-long-url',
    templateUrl: './too-long-url.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoTooLongUrlComponent {
}
